import { render, staticRenderFns } from "./SandboxLooksEditPage.vue?vue&type=template&id=5fda8da7&scoped=true&"
import script from "./SandboxLooksEditPage.vue?vue&type=script&lang=ts&"
export * from "./SandboxLooksEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./SandboxLooksEditPage.vue?vue&type=style&index=0&id=5fda8da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda8da7",
  null
  
)

export default component.exports